import { trackEvent } from '@/api/track';
import type { DomainGroup, PageItem } from '@/types/dashboard';

export const getTrackingErrorCode = (error: unknown) => {
  const maybeError = error as {
    code?: string | number;
    message?: string;
    name?: string;
    response?: { status?: number; data?: { code?: string | number; errorCode?: string | number } };
  };

  return String(
    maybeError.response?.data?.code ??
      maybeError.response?.data?.errorCode ??
      maybeError.response?.status ??
      maybeError.code ??
      maybeError.name ??
      maybeError.message ??
      'unknown',
  );
};

export const getDashboardCounts = (domainGroups: DomainGroup[], drafts: PageItem[]) => {
  const domainCount = domainGroups.length;
  const draftCount = drafts.length;
  const liveCount = domainGroups.reduce((count, group) => count + group.pages.length, 0);

  return {
    domainCount,
    pageCount: liveCount + draftCount,
    draftCount,
    liveCount,
  };
};

export const trackDashboardDataLoadResult = (data: {
  result: 'success' | 'failed';
  source: 'project_list' | 'stats_summary' | 'daily_briefing';
  domainCount?: number;
  pageCount?: number;
  draftCount?: number;
  liveCount?: number;
  durationMs: number;
  errorCode?: string | null;
}) => {
  trackEvent({
    eventCode: 'dashboard_data_load_result',
    eventData: JSON.stringify({
      result: data.result,
      source: data.source,
      domainCount: data.domainCount ?? 0,
      pageCount: data.pageCount ?? 0,
      draftCount: data.draftCount ?? 0,
      liveCount: data.liveCount ?? 0,
      durationMs: data.durationMs,
      errorCode: data.errorCode ?? null,
    }),
  });
};
